import axiosPrivate from "./axiosPrivate";

const getProveedores = (buscar = "") => {
  return axiosPrivate.get("proveedores", { params: { buscar } }).then(res => res.data);
};

const guardarProveedor = (data, id = null) => {
  if (id) {
    return axiosPrivate.post(`proveedores/${id}`, data).then(res => res.data);
  }

  return axiosPrivate.post("proveedores", data).then(res => res.data);
};

const eliminarProveedor = (id) => {
  return axiosPrivate.delete(`proveedores/${id}`).then(res => res.data);
};

const ProveedoresService = {
  getProveedores,
  guardarProveedor,
  eliminarProveedor,
};

export default ProveedoresService;
